<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>
<div class="col-12 col-sm-3 col-md-3 col-lg-3 ">
  <nb-card style="width: 400px;margin-top: -1rem">
    <nb-card-header style="background: #0170bf !important;color: white"><button type="button" class="close"
        (click)="onNoClick()">
        ×</button>Add Workorder Note</nb-card-header>
    <nb-card-body>
      <form>
        <textarea placeholder="Add work order note" name="txtWoNote" [(ngModel)]="woNoteDescription"></textarea>
        <button mat-raised-button class="btn btn-semi-round w-40 mt-2 bgBlue pull-right" (click)="saveWoNote()">
          Save
        </button>
      </form>
    </nb-card-body>
    <nb-card-footer style="padding: 0.25rem;">
      <button #btnClose mat-raised-button class="btn btn-semi-round w-40 mt-2 bgBlue pull-right" (click)="onNoClick()">
        Close
      </button>
    </nb-card-footer>
  </nb-card>
</div>